export const PERFURADOR_SOLO = {
    Codigo: 11,
    Nome: 'Perfurador de Solo',
    Capa: null, 
    Imagens: [
        {
            Capa: true,
            Ativo: true,
            Url: "assets/IPB/Produtos/Perfurador_Solo/perfurador_1.png"
        }
    ],
    Detalhes: [
        `Caixa de Transmissão Inpel com baixa rotação banhada em óleo`,
        `Eixo cardan telescopio`,
        `Opção de broca 9,12 (padrão) e 18 polegadas`,
        `Broca screw`,
        `Capacidade de perfuração: 1 metro`,
        `Ponteiras de corte substituíveis`,
        `Mola niveladora de grau de perfuração`,
        `Opcional cardan com embreagem`,
    ],
    Modelos: [
        { Modelo: 'BR-12' }
    ]
}